import React from 'react'
import images from 'assets/img'
import Header from './Header'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function NoUsers({ t }) {
  return (
    <section className="w-full bg-white p-4 lg:py-8 lg:px-12 rounded-xl mb-5 shadow-sm">
      <Header />
      <div className="w-full h-80 flex flex-col items-center justify-center">
        <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-border-lines">
          <img src={images.Usergroup} alt="" className="" />
        </div>
        
        <p className="text-placeholder w-3/5 mx-auto text-center">{ t('settings.user_management.empty') }</p>
      </div>
    </section>
  )
})
